import { render, staticRenderFns } from "./modalAnalisar.vue?vue&type=template&id=661f85ac"
import script from "./modalAnalisar.vue?vue&type=script&lang=js"
export * from "./modalAnalisar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports